export default __webpack_public_path__ + "img/list4.6682c701.jpg";